import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  AdminRemoveBuyersFromListMutation,
  AdminRemoveBuyersFromListMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const adminRemoveBuyersFromListMutation = graphql(`
  mutation adminRemoveBuyersFromList($input: RemoveBuyersFromListInput!) {
    adminRemoveBuyersFromList(input: $input) {
      id
      name
    }
  }
`);

type RemoveEntriesParams = { buyerListGuid: string; buyerGuids: string[] };

export function useAdminRemoveBuyerEntries(
  options?: UseMutationOptions<
    AdminRemoveBuyersFromListMutation,
    unknown,
    AdminRemoveBuyersFromListMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { mutate: innerMutate, ...rest } = useGraphQlMutation(adminRemoveBuyersFromListMutation, {
    ...options,
    onSuccess: (data, variables, context) => {
      void queryClient.invalidateQueries(["buyerLists"]);
      void queryClient.invalidateQueries(["buyerList", variables.input.id]);
      options?.onSuccess?.(data, variables, context);
    },
  });
  return {
    ...rest,
    mutate: ({ buyerListGuid, buyerGuids }: RemoveEntriesParams) =>
      innerMutate({ input: { id: buyerListGuid, buyerIds: buyerGuids } }),
  };
}
